import { render, staticRenderFns } from "./RefileNeeded.vue?vue&type=template&id=ba8226c0&scoped=true&"
import script from "./RefileNeeded.vue?vue&type=script&lang=js&"
export * from "./RefileNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8226c0",
  null
  
)

export default component.exports